module.exports = __webpack_public_path__ + "img/PVP_NorseTechWarDog_Upgrade2_ua.0cd377f6.webp";